<header>
  <div fxLayout="row" fxLayoutAlign="space-between center" class="container">
    <div fxFlex="20" fxFlex.xs="100" class="logo">
      <img src="assets/images/logo.svg" routerLink="/" loading="lazy" />
    </div>
    <div fxFlex fxLayoutAlign="end">
      <div fxHide.xs *ngIf="checkForLandingPage()" class="cursor_pointer">
        <div (click)="redirectToShadowfax()" class="gotoTxt">
          Go Back to <span>Shadowfax.in</span>
        </div>
      </div>
      <div
        *ngIf="!checkForHref()"
        class="needHelp cursor_pointer"
        [ngClass]="{ disabled: !commonService.getCookie('awb_number') }"
        (click)="openOTPPopupWithParam()"
        #triggerRef
      >
        <div><span class="material-icons">headset_mic</span></div>
        &nbsp;
        <div><span fxHide.xs> Need</span><span> Help?</span></div>
      </div>
      <div
        class="open-issue-count"
        *ngIf="commonService.customerOpenIssues != 0"
      >
        {{ commonService.customerOpenIssues }}
      </div>
      <!-- Help Popup Box -->
      <div *ngIf="showHelpPopup" class="help-popup-box" #helpPopup>
        <div class="help-option" (click)="raiseTicket()">
          <mat-icon class="help-icon">help</mat-icon>
          <span>Raise a Ticket</span>
          <mat-icon class="arrow-icon">chevron_right</mat-icon>
        </div>
        <!--
        <a href="tel:+91-80681 72518" class="help-option margin-btm-12">
          <mat-icon class="help-icon">call</mat-icon>
          <span>Call us on +91-80681 72518</span>
        </a>
        -->
        <!--
        <a *ngIf="commonService.whatsappChatUrl" [href]="commonService.whatsappChatUrl" target="_blank" class="help-option">
          <mat-icon class="help-icon">chat</mat-icon>
          <span>Chat with us</span>
        </a>
        -->
      </div>
    </div>
  </div>
</header>
